module.exports = __webpack_public_path__ + "media/SWV-I_DW_3_Oehlsche_Schreibweise.7aa173c0.mp3";